import { render, staticRenderFns } from "./OfferDeliveryAddress.vue?vue&type=template&id=5a5fee63&"
import script from "./OfferDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./OfferDeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports